import { render, staticRenderFns } from "./powelechart.vue?vue&type=template&id=6dec3de6&scoped=true&"
import script from "./powelechart.vue?vue&type=script&lang=js&"
export * from "./powelechart.vue?vue&type=script&lang=js&"
import style0 from "./powelechart.vue?vue&type=style&index=0&id=6dec3de6&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec3de6",
  null
  
)

export default component.exports